import React, {useEffect, useState} from 'react'
import {AsideDefault} from './components/aside/AsideDefault'
// import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {MasterInit} from './MasterInit'
import {PageDataProvider} from './core'
import {DrawerMessenger, ActivityDrawer, Main, InviteUsers, UpgradePlan, DrawerDashboard} from '../partials'
import {ModalMultiLanguage} from './core/ModalMultiLanguage'

type Props = {
  children?: React.ReactNode
}

const MasterLayout: React.FC<Props> = ({children}) => {
  const [openModal, setOpenModal] = useState(false)
  const [selectedText, setSelectedText] = useState<string | undefined>('')

  const handleContextMenu = (e: any) => {
    if (window.getSelection()?.toString()) {
      e.preventDefault()
      setSelectedText(window.getSelection()?.toString())
      setOpenModal(true)
    }
  }

  const handleCloseModal = (close: boolean) => {
    setOpenModal(close)
  }

  useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu)
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
    }
  })

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            {/* <Toolbar /> */}
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>{children}</Content>
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      <DrawerMessenger />
      <DrawerDashboard />
      <ModalMultiLanguage show={openModal} handleCloseModal={handleCloseModal} content={selectedText} />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <Main />
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}

      <MasterInit />
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
